
const SystemSettingsTranslation = {
    _partnerPmsDataRefreshTimeInSeconds: {
        pt_br: 'Tempo de atualização dos dados no PMS parceiro (em segundos)',
        en_us: 'Time to update the data in the partner PMS (in seconds)',
        es_es: 'Tiempo necesario para actualizar los datos en el PMS asociado (en segundos)'
    },

    _partnerPmsDefault: {
        pt_br: 'Sistema PMS parceiro',
        en_us: 'Partner PMS System',
        es_es: 'Sistema PMS asociado'
    },

    _analyticsUrl: {
        pt_br: 'Url do Power BI',
        en_us: 'Power BI Url',
        es_es: 'Url de Power BI'
    },

    _sendEmailUsername: {
        pt_br: 'Nome de usuário utilizado no envio de e-mails',
        en_us: 'Username used when sending emails',
        es_es: 'Nombre de usuario utilizado al enviar correos electrónicos'
    },

    _sendEmailEmail: {
        pt_br: 'E-mail utilizado no envio de e-mails',
        en_us: 'Email used to send emails',
        es_es: 'Correo electrónico utilizado para enviar correos electrónicos'
    },

    _sendEmailPassword: {
        pt_br: 'Senha utilizada para autenticação do e-mail no envio de e-mails',
        en_us: 'Password used for email authentication when sending emails',
        es_es: 'Contraseña utilizada para la autenticación de correo electrónico al enviar correos electrónicos'
    },

    _sendEmailSecurityLevel: {
        pt_br: 'Nível de segurança utilizado no envio de e-mails',
        en_us: 'Security level used when sending emails',
        es_es: 'Nivel de seguridad utilizado al enviar correos electrónicos'
    },

    _sendEmailProtocol: {
        pt_br: 'Protocolo utilizado no envio de e-mails',
        en_us: 'Protocol used to send emails',
        es_es: 'Protocolo utilizado para enviar correos electrónicos'
    },

    _sendEmailServer: {
        pt_br: 'Servidor de domínio utilizado no envio de e-mails',
        en_us: 'Domain server used for sending emails',
        es_es: 'Servidor de dominio utilizado para enviar correos electrónicos'
    },

    _sendEmailPort: {
        pt_br: 'Porta do servidor de domínio utilizado no envio de e-mails',
        en_us: 'Domain server port used to send emails',
        es_es: 'Puerto del servidor de dominio utilizado para enviar correos electrónicos'
    },

    _systemVersion: {
        pt_br: 'Versão do sistema',
        en_us: 'System version',
        es_es: 'Versión del sistema'
    }
}

export default SystemSettingsTranslation;